export const VANTIFY_WORK_ORDER_PRIORITY_ID = 4;
